import Character from "@lss/common/src/shell/Character";



interface LenaPropertiesINT {
}

const lenaProperties: LenaPropertiesINT = {
};

const lena = new Character<LenaPropertiesINT>("Lena", lenaProperties, "#FF63C7FF");











export {
    lena,
};
